import State from 'store/State';

import { AggregationField } from '../../aggregation/fields/aggregationFieldPortfolio';
import { useSelector } from 'react-redux';
import {
    PortfolioSummarySharedConfigurationState,
    initialPortfolioSummarySharedConfigurationState,
} from './PortfolioSummarySharedConfigurationState';
import { selectWidgetsSharedConfigState } from 'widgets/store/sharedConfiguration/selectors';

export const selectPortfolioSummarySharedConfigState: (
    state: State
) => PortfolioSummarySharedConfigurationState = (state) => {
    return (
        selectWidgetsSharedConfigState(state).portfolioSummary ||
        initialPortfolioSummarySharedConfigurationState
    );
};

export const selectPortfolioSummaryRecentlyUsedAggregationFields: (
    state: State
) => AggregationField[] = (state) => {
    return (
        selectPortfolioSummarySharedConfigState(state)
            ?.recentlyUsedAggregationFields || []
    );
};

export const useSelectPortfolioSummaryRecentlyUsedAggregationFields = () =>
    useSelector(selectPortfolioSummaryRecentlyUsedAggregationFields);
